import { useState, useCallback, useEffect } from 'react';
import type { ActivePopupModel } from '@pages/administration/announcements/announcements.models';
import { popupsApi } from '@pages/administration/announcements/popupsApi';

export interface AnnouncementPopupProps {
    announcements: ActivePopupModel[];
    skipMarkAsRead?: boolean;
}

export function useAnnouncementPopup(props: AnnouncementPopupProps) {
    const [remaining, setRemaining] = useState<ActivePopupModel[]>([]);

    useEffect(() => {
        if (props.announcements.length === 0) return;
        setRemaining([...props.announcements].sort((a, b) => b.PopupTypeId - a.PopupTypeId));
    }, [props.announcements]);

    const handleClose = useCallback(() => {
        const current = remaining[0];
        if (!current) return;

        if (!props.skipMarkAsRead) {
            popupsApi.markPopupAsRead(current.Guid).catch((err) => {
                console.error('Failed to mark popup as read:', err);
            });
        }

        setRemaining((prev) => prev.slice(1));
    }, [remaining, props.skipMarkAsRead]);

    return {
        state: {
            current: remaining[0] ?? null,
        },
        handlers: {
            handleClose,
        },
    };
}
